export const isValidYYYYFormat = (input) => {
  if (typeof input !== 'number' || !Number.isInteger(input)) {
    return false
  }
  const inputTosTringParsed = String(input)
  // eslint-disable-next-line
  if (inputTosTringParsed.length !== 4 || inputTosTringParsed[0] === '0') return false
  return true
}
